import { TranslationKeysByPath } from '@/localization';
import { ComponentPropsWithoutRef, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type CampaignDetailsSectionProps = { header?: TranslationKeysByPath<'campaign'> } & ComponentPropsWithoutRef<'article'>;

export const CampaignDetailsSection: FC<CampaignDetailsSectionProps> = ({ header, className, children, ...rest }) => {
  const { t } = useTranslation('campaign');

  return (
    <article className={twMerge('flex flex-col gap-2', className)} {...rest}>
      {header ? <h2 className='text-lg font-bold text-gray-900'>{t(header) as any}</h2> : null}
      {children}
    </article>
  );
};
